"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeperatorComponentWebsiteRender = exports.SeperatorComponentEditor = exports.SeperatorComponentCreator = exports.SeperatorComponentRender = void 0;
const react_1 = __importDefault(require("react"));
const structure_1 = require("./structure");
function SeperatorComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const style = component.style;
    return react_1.default.createElement("hr", { style: style });
}
exports.SeperatorComponentRender = SeperatorComponentRender;
function SeperatorComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState('');
    react_1.default.useEffect(() => {
        dispatch((0, structure_1.seperatorObject)([]));
    }, []);
    return react_1.default.createElement("hr", null);
}
exports.SeperatorComponentCreator = SeperatorComponentCreator;
function SeperatorComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    return react_1.default.createElement("hr", { style: component.style });
}
exports.SeperatorComponentEditor = SeperatorComponentEditor;
function SeperatorComponentWebsiteRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const style = component.style;
    return react_1.default.createElement("hr", { style: style });
}
exports.SeperatorComponentWebsiteRender = SeperatorComponentWebsiteRender;
